export default __webpack_public_path__ + "static/media/explore_destination_img7.fe57ec7a.jpg";